import React from "react";
import { AlertTriangle, RotateCcw } from "lucide-react";

export default class ErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Sir Monty ERP crashed:", error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center p-6" style={{ background: "#FBF8F2" }}
        data-testid="error-boundary">
        <div className="max-w-lg w-full rounded-2xl bg-white border p-7 text-center" style={{ borderColor: "#EFE7DA" }}>
          <div className="w-12 h-12 rounded-2xl mx-auto flex items-center justify-center mb-4" style={{ background: "#FBE9E9" }}>
            <AlertTriangle size={22} style={{ color: "#C62828" }} />
          </div>
          <h1 className="font-brand font-bold text-2xl mb-2" style={{ color: "#33221E" }}>Something went wrong</h1>
          <p className="text-sm mb-5" style={{ color: "#8B7355" }}>
            This screen hit an unexpected error. Your data is safe — nothing was saved. Reload to carry on,
            and let us know what you were doing if it keeps happening.
          </p>
          <div className="flex gap-2 justify-center">
            <button onClick={() => window.location.reload()} data-testid="error-boundary-reload"
              className="inline-flex items-center gap-2 h-11 px-5 rounded-xl text-sm font-semibold text-white"
              style={{ background: "#8B1E1E" }}>
              <RotateCcw size={16} /> Reload this page
            </button>
            <button onClick={() => { window.location.href = "/"; }} data-testid="error-boundary-home"
              className="inline-flex items-center gap-2 h-11 px-5 rounded-xl text-sm font-semibold border"
              style={{ borderColor: "#EFE7DA", color: "#33221E" }}>
              Back to dashboard
            </button>
          </div>
          {process.env.NODE_ENV !== "production" && (
            <pre className="mt-5 text-left text-[11px] p-3 rounded-xl overflow-auto max-h-40"
              style={{ background: "#FDFBF6", color: "#8B7355" }}>
              {String(this.state.error?.stack || this.state.error)}
            </pre>
          )}
        </div>
      </div>
    );
  }
}
